import db from '@/firebase/init'

export default {

    data () {
        return {
          callbells: {
            count: 0,
            year: (new Date()).getFullYear(),
            month: ('0' + ((new Date()).getMonth() + 1)).slice(-2),
            months: ['01','02','03','04','05','06','07','08','09','10','11','12'],
            devices: [],
            cursor: 0,
            data: [],
            type: ''
          }
        }
      },

    methods: {

        callbellData(type) {

            this.callbells.devices = []
            this.callbells.cursor = 0
            this.callbells.data = []
            this.callbells.type = type
            for(var i in this.devices) {
              if(this.devices[i].data.type != 'callbell') { continue }
              this.$set(this.devices[i].data, 'remark', null)
              this.$set(this.devices[i].data, 'remarkClasses', null)
              if('checked' in this.devices[i].data && this.devices[i].data.checked) {
                this.callbells.devices.push(this.devices[i].id)
              }
            }
            this.callbellDataFetch()
      
          },
      
          callbellDataFetch() {
      
            if(this.callbells.cursor > this.callbells.devices.length - 1) { return this.callbellDataFinish() }
            var devId = this.callbells.devices[this.callbells.cursor]
            var devIx = this.devicesIndex[devId]
            this.$set(this.devices[devIx].data, 'remark', this.$t('callbell.laststatus.none'))
            this.$set(this.devices[devIx].data, 'remarkClasses', ['badge','badge-danger'])
            this.callbells.cursor++
            db.collection("devices/"+devId+"/logs").doc(this.callbells.year+this.callbells.month).get().then((doc) => {
                if (doc.exists) {
                    var data = []
                    var d = doc.data().rows
                    var waiting = false
                    var row = {}
                    var t = null
                    var i = -1;
                    for(i in d) {
                      if(waiting) {
                        if(d[i].ev == 'call') {
                          row.ac ++
                          row.a1 = d[i].time
                        } else {
                          row.b = d[i].time
                          this.callbells.data.push(JSON.parse(JSON.stringify(row)))
                          waiting = false
                        }
                      }
                      if(!waiting && d[i].ev == 'call') {
                        row = { 'ac': 1, 'a0': d[i].time, n: this.devices[devIx].data.name }
                        waiting = true
                      }
                    }
      
                    if(i > 0) {
                      this.$set(this.devices[devIx].data, 'remark', 
                        this.$t('callbell.laststatus.'+(d[i].ev == 'call' ? 'call' : 'cancel'),
                          {time: (new Date(d[i].time)).toISOString().substr(5,14).replace('T',' ')}))
                      this.$set(this.devices[devIx].data, 'remarkClasses', 
                        ['badge','badge-'+(d[i].ev == 'call' ? 'warning' : 'success')])
                    }
                    return this.callbellDataFetch()
                } else {
                    return this.callbellDataFetch()
                }
            }).catch((error) => {
              console.log(error)
              return this.callbellDataFetch()
            })
          },
      
          callbellDataFinish() {
            if(this.callbells.data.length < 1) { return }
            this.callbells.data.sort(function (a, b) { return (a.a0 === b.a0) ? 0 : ((a.a0 < b.a0) ? -1 : 1) })
            if(this.callbells.type == 'grf') {
              this.chartDev.data = this.callbells.data
              this.openChart(null, 'CallbellMonthly')
            } else {
              var csvData = []
              for(var i in this.callbells.data) {
                csvData.push([
                  (new Date(this.callbells.data[i].a0)).toISOString().substr(0,10),
                  '' + this.callbells.data[i].n,
                  (new Date(this.callbells.data[i].a0)).toISOString().substr(11,8),
                  (new Date(this.callbells.data[i].b)).toISOString().substr(11,8),
                  (new Date(this.callbells.data[i].b - this.callbells.data[i].a0)).toISOString().substr(11,8),
                  this.callbells.data[i].ac
                ])
              }
              csvData.unshift(['Day','Counter','Called','Cancelled','Time','Calls']) //TODO: i18n
              this.downloadCsv(csvData, 'callbell_')
            }
          }
          
    }

}


// WEBPACK FOOTER //
// ./src/components/Devices/Callbell.js